import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Defensive check for Environment Variables
if (!process.env.REACT_APP_FIREBASE_API_KEY) {
  console.warn("⚠️ [FIREBASE] Critical environment variables are missing. Development/Local mode may be restricted.");
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase state
let app = null;
let auth = null;
let db = null;
let googleProvider = null;

try {
  if (!process.env.REACT_APP_FIREBASE_API_KEY) {
    throw new Error("Missing Firebase ENV");
  }

  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  db = getFirestore(app);
  googleProvider = new GoogleAuthProvider();

  console.log("✅ [FIREBASE] Initialized successfully");
} catch (error) {
  console.error("❌ [FIREBASE] Initialization failed:", error.message);
  // SAFE fallback: service remains null to avoid consistent state lies
  auth = null;
  db = null;
  googleProvider = null;
}

export { auth, db, googleProvider };
export default app;
